import script from "./ToolsTranslateTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolsTranslateTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ToolsTranslateTemplate.vue?vue&type=style&index=0&id=7769274d&lang=css"

const __exports__ = script;

export default __exports__